module.exports = __webpack_public_path__ + "static/media/algo.72e44275.jpg";